import { useTheme } from "@emotion/react";
import { Button, ButtonGroup, Typography } from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "firebaseApp";
import React, { useRef, useState } from "react";
import SectionContainer from "components/ai-editor/SectionContainer";
import AITextEditMenuItem from "components/ai-editor/AITextEditMenuItem";

export const HEADER_TYPE = {
  key: "header",
  default: {
    text: "",
    headerType: "section",
  },
};

export default function Header({ section, dragHandleProps }) {
  const theme = useTheme();
  const ref = useRef(null);

  const [headerType, setHeaderType] = useState(section.headerType);
  const [saving, setSaving] = useState(false);

  const save = async (newData = {}) => {
    try {
      setSaving(true);
      await updateDoc(
        doc(db, "documents", section.documentId, "sections", section.id),
        {
          text: ref.current.innerText,
          headerType: headerType,
          ...newData,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setSaving(false);
    }
  };

  const getVariant = () => {
    if (headerType === "title") return "h3";
    if (headerType === "subsection") return "h6";
    return "h4";
  };

  const handleSetType = (type) => {
    setHeaderType(type);
    save({
      headerType: type,
    });
  };

  return (
    <SectionContainer 
      section={section} 
      dragHandleProps={dragHandleProps} 
      saving={saving}
      menuItems={[
        <AITextEditMenuItem
          text={section.text}
          setText={(text) => save({text})}
        />
      ]}
    >
      <Typography
        sx={{
          color: theme.palette.text.main,
          marginBottom: "24px",
        }}
        variant={getVariant()}
        contentEditable
        suppressContentEditableWarning={true}
        onBlur={() => save()}
        ref={ref}
      >
        {section.text}
      </Typography>
      <ButtonGroup
        size="small"
        sx={{
          position: "absolute",
          right: 0,
          bottom: 0,
        }}
        color="secondary"
      >
        <Button
          variant={headerType === "title" ? "contained" : "outlined"}
          onClick={() => handleSetType("title")}
        >
          L
        </Button>
        <Button
          onClick={() => handleSetType("section")}
          variant={headerType === "section" ? "contained" : "outlined"}
        >
          M
        </Button>
        <Button
          onClick={() => handleSetType("subsection")}
          variant={headerType === "subsection" ? "contained" : "outlined"}
        >
          S
        </Button>
      </ButtonGroup>
    </SectionContainer>
  );
}
